import { z } from 'zod'

// ---------------------------------------------------------------------------
// Mascot avatar (architect-directed addition, see docs/DEVIATIONS.md "api")

export const AVATAR_FAMILIES = ['mochi', 'lumi', 'nova', 'bop', 'nimbus', 'pico', 'aura', 'mellow', 'comet', 'glim'] as const
export const AvatarFamily = z.enum(AVATAR_FAMILIES)
export type AvatarFamily = z.output<typeof AvatarFamily>

/** Fixed pastel palette scheme ids. */
export const AVATAR_PALETTES = ['ivory', 'mint', 'lilac', 'peach', 'sky', 'plum', 'sage', 'pearl'] as const
export const AvatarPalette = z.enum(AVATAR_PALETTES)
export type AvatarPalette = z.output<typeof AvatarPalette>

export const AVATAR_EXPRESSIONS = ['smile', 'happy', 'sleepy', 'curious', 'focused', 'wink'] as const
export const AvatarExpression = z.enum(AVATAR_EXPRESSIONS)
export type AvatarExpression = z.output<typeof AvatarExpression>

export const AVATAR_MATERIALS = ['jelly', 'matte', 'frosted', 'velvet', 'quilted'] as const
export const AvatarMaterial = z.enum(AVATAR_MATERIALS)
export type AvatarMaterial = z.output<typeof AvatarMaterial>

/** Short slug for avatar accessories (headwear, outfit, loadout). */
export const AvatarSlug = z.string().regex(/^[a-z0-9]+(?:[-_][a-z0-9]+)*$/, 'expected a lower-case slug').max(32)

/** Structured mascot avatar of an agent (`agents.agents.avatar`). */
export const AgentAvatar = z.object({
  family: AvatarFamily,
  palette: AvatarPalette,
  expression: AvatarExpression.optional(),
  material: AvatarMaterial.optional(),
  headwear: AvatarSlug.optional(),
  outfit: AvatarSlug.optional(),
  loadout: AvatarSlug.optional(),
})
export type AgentAvatar = z.output<typeof AgentAvatar>

